'use client';

import { useState, useEffect } from 'react';

interface OfflineReadyBannerProps {
  offlineReady: boolean;
  needsUpdate: boolean;
  onUpdate: () => void;
}

export default function OfflineReadyBanner({ offlineReady, needsUpdate, onUpdate }: OfflineReadyBannerProps) {
  const [showReady, setShowReady] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    if (offlineReady) {
      setShowReady(true);
      const t = setTimeout(() => setShowReady(false), 3500);
      return () => clearTimeout(t);
    }
  }, [offlineReady]);

  useEffect(() => {
    if (needsUpdate) setShowUpdate(true);
  }, [needsUpdate]);

  if (!showReady && !showUpdate) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
        pointerEvents: 'none',
      }}
    >
      {showReady && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            borderRadius: '9999px',
            background: 'hsl(var(--card, 240 14% 98%))',
            border: '1px solid hsl(var(--border, 240 10% 85%))',
            color: 'hsl(var(--foreground, 220 9% 20%))',
            fontSize: '0.8125rem',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            whiteSpace: 'nowrap',
            pointerEvents: 'auto',
          }}
        >
          <span style={{ color: 'hsl(var(--primary, 30 62% 72%))' }}>✓</span>
          Perfil guardado — funciona sin internet
          <button
            onClick={() => setShowReady(false)}
            aria-label="Cerrar"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: 'hsl(var(--muted-foreground, 240 5% 45%))',
              fontSize: '1rem',
              lineHeight: 1,
              padding: '0 0 0 0.25rem',
            }}
          >
            ×
          </button>
        </div>
      )}

      {showUpdate && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            padding: '0.5rem 1rem',
            borderRadius: '9999px',
            background: 'hsl(var(--card, 240 14% 98%))',
            border: '1px solid hsl(var(--border, 240 10% 85%))',
            color: 'hsl(var(--foreground, 220 9% 20%))',
            fontSize: '0.8125rem',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            whiteSpace: 'nowrap',
            pointerEvents: 'auto',
          }}
        >
          <span>Actualización disponible</span>
          <button
            onClick={onUpdate}
            style={{
              background: 'hsl(var(--primary, 30 62% 72%))',
              color: 'hsl(var(--primary-foreground, 25 50% 10%))',
              border: 'none',
              borderRadius: '9999px',
              padding: '0.25rem 0.75rem',
              fontSize: '0.75rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Actualizar
          </button>
          <button
            onClick={() => setShowUpdate(false)}
            aria-label="Cerrar"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: 'hsl(var(--muted-foreground, 240 5% 45%))',
              fontSize: '1rem',
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}
